const ITEMS = ["Haya", "Noor", "Jamal", "Aqiqah Mubarak", "A Fairytale Begins", "19 · 10 · 2026", "Written In The Stars"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-amber-200/10 bg-[#0a0c1c] py-5">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-royal text-lg sm:text-xl tracking-[0.35em] uppercase text-amber-100/70 px-8">
                  {item}
                </span>
                <span className="text-amber-300/60 text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
